"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CRON_PERIOD_YEARLY = exports.CRON_PERIOD_WEEKLY = exports.CRON_PERIOD_MONTHLY = exports.CRON_PERIOD_MINUTELY = exports.CRON_PERIOD_HOURLY = exports.CRON_PERIOD_DAILY = void 0;
exports.getCronValue = getCronValue;

require("core-js/modules/es.array.concat");

require("antd/lib/select/style");

var _select = _interopRequireDefault(require("antd/lib/select"));

require("antd/lib/checkbox/style");

var _checkbox = _interopRequireDefault(require("antd/lib/checkbox"));

require("antd/lib/form/style");

var _form = _interopRequireDefault(require("antd/lib/form"));

require("antd/lib/radio/style");

var _radio = _interopRequireDefault(require("antd/lib/radio"));

require("antd/lib/input/style");

var _input = _interopRequireDefault(require("antd/lib/input"));

require("antd/lib/input-number/style");

var _inputNumber = _interopRequireDefault(require("antd/lib/input-number"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.number.is-nan.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _cronParser = _interopRequireDefault(require("cron-parser"));

var _moment = _interopRequireDefault(require("moment"));

var _hooks = require("../hooks");

var _TimePicker = _interopRequireDefault(require("./TimePicker"));

var _excluded = ["dayInputProps", "enableDaily", "enableHourly", "enableMinutely", "enableMonthly", "enableWeekly", "enableYearly", "everyCountInputProps", "minuteInputProps", "onChange", "period", "showThreeLetterDay", "timePickerInputProps", "value", "weekCheckboxGroupProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = (0, _react.forwardRef)(CronInput);

exports.default = _default;
var CRON_PERIOD_MINUTELY = 'minutely';
exports.CRON_PERIOD_MINUTELY = CRON_PERIOD_MINUTELY;
var CRON_PERIOD_HOURLY = 'hourly';
exports.CRON_PERIOD_HOURLY = CRON_PERIOD_HOURLY;
var CRON_PERIOD_DAILY = 'daily';
exports.CRON_PERIOD_DAILY = CRON_PERIOD_DAILY;
var CRON_PERIOD_WEEKLY = 'weekly';
exports.CRON_PERIOD_WEEKLY = CRON_PERIOD_WEEKLY;
var CRON_PERIOD_MONTHLY = 'monthly';
exports.CRON_PERIOD_MONTHLY = CRON_PERIOD_MONTHLY;
var CRON_PERIOD_YEARLY = 'yearly';
exports.CRON_PERIOD_YEARLY = CRON_PERIOD_YEARLY;

function getCronValue(state) {
  var cronValue = '* * * * *';
  var everyCountStr = state.everyCount === 1 ? '' : "/".concat(state.everyCount);

  if (state.cronPeriod === CRON_PERIOD_MINUTELY) {
    cronValue = "*".concat(everyCountStr, " * * * *");
  } else if (state.cronPeriod === CRON_PERIOD_HOURLY) {
    cronValue = "".concat(state.minute, " *").concat(everyCountStr, " * * *");
  } else if (state.cronPeriod === CRON_PERIOD_DAILY) {
    cronValue = "".concat(state.minute, " ").concat(state.hour, " *").concat(everyCountStr, " * *");
  } else if (state.cronPeriod === CRON_PERIOD_MONTHLY) {
    cronValue = "".concat(state.minute, " ").concat(state.hour, " ").concat(state.dayOfMonth, " *").concat(everyCountStr, " *");
  } else if (state.cronPeriod === CRON_PERIOD_YEARLY) {
    cronValue = "".concat(state.minute, " ").concat(state.hour, " ").concat(state.dayOfMonth, " ").concat(state.month, " *");
  } else if (state.cronPeriod === CRON_PERIOD_WEEKLY) {
    var dayOfWeekStr = [0, 8].includes(state.dayOfWeek.length) ? '*' : state.dayOfWeek.join(',');
    cronValue = "".concat(state.minute, " ").concat(state.hour, " * * ").concat(dayOfWeekStr);
  }

  return cronValue;
}

function parseValue(value) {
  var cronPeriod = null;
  var minute = 0;
  var hour = null;
  var month = null;
  var everyCount = 1;
  var dayOfMonth = [];
  var dayOfWeek = [];

  try {
    var cronObject = _cronParser.default.parseExpression(value);

    var _cronObject$_fields = cronObject._fields,
        parsedDayOfMonth = _cronObject$_fields.dayOfMonth,
        parsedDayOfWeek = _cronObject$_fields.dayOfWeek,
        parsedHour = _cronObject$_fields.hour,
        parsedMinute = _cronObject$_fields.minute,
        parsedMonth = _cronObject$_fields.month;

    if (parsedMinute.length > 1 && parsedMinute.length <= 60) {
      cronPeriod = CRON_PERIOD_MINUTELY;
      everyCount = parsedMinute[1] - parsedMinute[0];
      minute = everyCount;
    }

    if (parsedMinute.length === 1 || parsedHour.length > 1 && parsedHour.length < 24) {
      cronPeriod = CRON_PERIOD_HOURLY;
      everyCount = parsedHour[1] - parsedHour[0];
      minute = parsedMinute[0];
    }

    if (parsedHour.length === 1 || parsedDayOfMonth.length > 1 && parsedDayOfMonth.length < 31) {
      cronPeriod = CRON_PERIOD_DAILY;
      everyCount = parsedDayOfMonth[1] - parsedDayOfMonth[0];
      hour = parsedHour[0];
      minute = parsedMinute[0];
    }

    if (parsedDayOfMonth.length === 1 || parsedMonth.length > 1 && parsedMonth.length < 12) {
      cronPeriod = CRON_PERIOD_MONTHLY;
      everyCount = parsedMonth[1] - parsedMonth[0];
      dayOfMonth = parsedDayOfMonth[0];
    }

    if (parsedMonth.length === 1) {
      cronPeriod = CRON_PERIOD_YEARLY;
      everyCount = parsedDayOfMonth[1] - parsedDayOfMonth[0];
      month = parsedMonth[0];
    }

    if (parsedDayOfWeek.length < 7) {
      cronPeriod = CRON_PERIOD_WEEKLY;
      dayOfWeek = parsedDayOfWeek;
    }
  } catch (e) {
    console.warn(e);
  }

  return {
    cronPeriod: cronPeriod,
    dayOfMonth: dayOfMonth,
    dayOfWeek: dayOfWeek,
    everyCount: everyCount,
    hour: hour,
    minute: minute,
    month: month
  };
}

var defaults = {
  cronPeriod: 'hourly',
  cronValue: null,
  dayOfMonth: 1,
  dayOfWeek: [0],
  everyCount: 1,
  hour: 0,
  minute: 0,
  month: 1
};
var ACTION_SET_CRON_PERIOD = 'SET_CRON_PERIOD';
var ACTION_SET_DAY_OF_MONTH = 'SET_DAY_OF_MONTH';
var ACTION_SET_DAY_OF_WEEK = 'SET_DAY_OF_WEEK';
var ACTION_SET_EVERY_COUNT = 'SET_EVERY_COUNT';
var ACTION_SET_MINUTE = 'SET_MINUTE';
var ACTION_SET_MONTH = 'SET_MONTH';
var ACTION_SET_TIME = 'SET_TIME';
var ACTION_VALUE_CHANGED = 'VALUE_CHANGED';

var createAction = function createAction(type, data) {
  return {
    type: type,
    data: data
  };
};

var reducer = function reducer(state, action) {
  var newState;

  switch (action.type) {
    case ACTION_SET_CRON_PERIOD:
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), defaults), {}, {
        cronPeriod: action.data
      });
      break;

    case ACTION_SET_DAY_OF_MONTH:
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        dayOfMonth: action.data
      });
      break;

    case ACTION_SET_DAY_OF_WEEK:
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        dayOfWeek: action.data
      });
      break;

    case ACTION_SET_EVERY_COUNT:
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        everyCount: action.data
      });
      break;

    case ACTION_SET_MONTH:
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        month: action.data
      });
      break;

    case ACTION_SET_TIME:
      var newTimeDate = action.data;
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        minute: newTimeDate.format('m'),
        hour: newTimeDate.format('H')
      });
      break;

    case ACTION_SET_MINUTE:
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        minute: action.data
      });
      break;

    case ACTION_VALUE_CHANGED:
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), parseValue(action.data));
      break;

    default:
      break;
  }

  newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, newState), {}, {
    cronValue: getCronValue(newState)
  });
  return newState;
};

function CronInput(_ref, ref) {
  var dayInputProps = _ref.dayInputProps,
      _ref$enableDaily = _ref.enableDaily,
      enableDaily = _ref$enableDaily === void 0 ? true : _ref$enableDaily,
      _ref$enableHourly = _ref.enableHourly,
      enableHourly = _ref$enableHourly === void 0 ? true : _ref$enableHourly,
      _ref$enableMinutely = _ref.enableMinutely,
      enableMinutely = _ref$enableMinutely === void 0 ? true : _ref$enableMinutely,
      _ref$enableMonthly = _ref.enableMonthly,
      enableMonthly = _ref$enableMonthly === void 0 ? true : _ref$enableMonthly,
      _ref$enableWeekly = _ref.enableWeekly,
      enableWeekly = _ref$enableWeekly === void 0 ? true : _ref$enableWeekly,
      _ref$enableYearly = _ref.enableYearly,
      enableYearly = _ref$enableYearly === void 0 ? true : _ref$enableYearly,
      everyCountInputProps = _ref.everyCountInputProps,
      minuteInputProps = _ref.minuteInputProps,
      onChange = _ref.onChange,
      period = _ref.period,
      showThreeLetterDay = _ref.showThreeLetterDay,
      timePickerInputProps = _ref.timePickerInputProps,
      value = _ref.value,
      weekCheckboxGroupProps = _ref.weekCheckboxGroupProps,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var initialState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, defaults), {}, {
    cronValue: value
  }, parseValue(value || '0 * * * *'));

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var prevState = (0, _hooks.usePreviousValue)(state);
  (0, _react.useEffect)(function () {
    if (prevState) {
      onChange && onChange(state.cronValue);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [state.cronValue]);

  var renderEveryCountField = function renderEveryCountField(unit, max) {
    return /*#__PURE__*/_react.default.createElement("span", null, "Every", ' ', /*#__PURE__*/_react.default.createElement(_inputNumber.default, Object.assign({
      "data-testid": "cron-input-every",
      value: state.everyCount,
      min: 1,
      max: max,
      onChange: function onChange(n) {
        return n && !Number.isNaN(Number(n)) && dispatch(createAction(ACTION_SET_EVERY_COUNT, n));
      }
    }, everyCountInputProps)), ' ', unit, state.everyCount > 1 ? 's' : '');
  };

  var renderTimePickerField = function renderTimePickerField() {
    return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_TimePicker.default, Object.assign({
      "data-testid": "cron-input-time",
      className: 'CronInput-time-picker',
      allowClear: false,
      format: 'HH:mm',
      value: (0, _moment.default)("".concat(state.hour, ":").concat(state.minute), 'H:m'),
      onChange: function onChange(v) {
        return v && dispatch(createAction(ACTION_SET_TIME, v));
      }
    }, timePickerInputProps)));
  };

  var renderDayField = function renderDayField() {
    return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_inputNumber.default, Object.assign({
      "data-testid": "cron-input-day",
      value: state.dayOfMonth,
      min: 1,
      max: 31,
      onChange: function onChange(n) {
        return n && !Number.isNaN(Number(n)) && dispatch(createAction(ACTION_SET_DAY_OF_MONTH, n));
      }
    }, dayInputProps)));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "cron-input"
  }, /*#__PURE__*/_react.default.createElement(_input.default, Object.assign({
    ref: ref
  }, rest, {
    type: "hidden",
    value: state.cronValue
  })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    style: {
      marginBottom: '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
    "data-testid": "cron-input-period",
    value: state.cronPeriod,
    onChange: function onChange(e) {
      return dispatch(createAction(ACTION_SET_CRON_PERIOD, e.target.value));
    }
  }, enableMinutely ? /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
    value: CRON_PERIOD_MINUTELY
  }, "Minutely") : null, enableHourly ? /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
    value: CRON_PERIOD_HOURLY
  }, "Hourly") : null, enableDaily ? /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
    value: CRON_PERIOD_DAILY
  }, "Daily") : null, enableWeekly ? /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
    value: CRON_PERIOD_WEEKLY
  }, "Weekly") : null, enableMonthly ? /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
    value: CRON_PERIOD_MONTHLY
  }, "Monthly") : null, enableYearly ? /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
    value: CRON_PERIOD_YEARLY
  }, "Yearly") : null)), function () {
    switch (state.cronPeriod) {
      case CRON_PERIOD_HOURLY:
        return /*#__PURE__*/_react.default.createElement(_form.default.Item, null, renderEveryCountField('hour', 23), ", at minute", ' ', /*#__PURE__*/_react.default.createElement(_inputNumber.default, Object.assign({
          "data-testid": "cron-input-minute",
          value: state.minute,
          min: 0,
          max: 59,
          onChange: function onChange(n) {
            return n && !Number.isNaN(Number(n)) && dispatch(createAction(ACTION_SET_MINUTE, n));
          }
        }, minuteInputProps)));

      case CRON_PERIOD_DAILY:
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_form.default.Item, null, renderEveryCountField('day', 31), ", at", ' ', renderTimePickerField()));

      case CRON_PERIOD_WEEKLY:
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_checkbox.default.Group, Object.assign({
          "data-testid": "cron-input-day-of-week",
          value: state.dayOfWeek,
          onChange: function onChange(v) {
            return dispatch(createAction(ACTION_SET_DAY_OF_WEEK, v));
          }
        }, weekCheckboxGroupProps), _moment.default.weekdays().map(function (d, i) {
          return /*#__PURE__*/_react.default.createElement(_checkbox.default, {
            key: i,
            value: i
          }, /*#__PURE__*/_react.default.createElement("span", {
            "data-testid": "cron-input-day-of-week-option-".concat(i)
          }, d.substring(0, showThreeLetterDay ? 3 : 1)));
        })), "At ", renderTimePickerField()));

      case CRON_PERIOD_MONTHLY:
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_form.default.Item, null, renderEveryCountField('month', 12), ", on the day ", renderDayField(), ", at", ' ', renderTimePickerField()));

      case CRON_PERIOD_YEARLY:
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_form.default.Item, null, "Every", ' ', /*#__PURE__*/_react.default.createElement(_select.default, {
          className: "CronInput_month-select",
          "data-testid": "cron-input-month",
          defaultValue: state.month,
          style: {
            width: 100
          },
          onChange: function onChange(v) {
            return dispatch(createAction(ACTION_SET_MONTH, v));
          }
        }, _moment.default.monthsShort().map(function (m, i) {
          return /*#__PURE__*/_react.default.createElement(_select.default.Option, {
            key: i + 1,
            value: i + 1,
            "data-testid": "cron-input-month-option-".concat(i)
          }, m);
        })), "\xA0, on the day ", renderDayField(), "\xA0, at ", renderTimePickerField()));

      case CRON_PERIOD_MINUTELY:
      default:
        return /*#__PURE__*/_react.default.createElement(_form.default.Item, null, renderEveryCountField('minute', 59));
    }
  }());
}